module.exports = __webpack_public_path__ + "f0efc720daf7086422fa60e29ddc0b0d.png";